var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye_1_",
    "data-name": "eye (1)",
    transform: "translate(0 0.148)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7071",
    "data-name": "Rectangle 7071",
    width: 27,
    height: 27,
    transform: "translate(0 -0.148)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64998",
    "data-name": "Path 64998",
    d: "M27.748,56C19.356,56,16,63.552,16,63.552S19.356,71.1,27.748,71.1,39.5,63.552,39.5,63.552,36.139,56,27.748,56Z",
    transform: "translate(-14.322 -50.126)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_597",
    "data-name": "Ellipse 597",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(9 8.852)",
    fill: "#fff8f8",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3075258275241f2cf5b68ae4dc29bb6b.svg";
export { ForwardRef as ReactComponent };